import React from "react";
import { useParams, useRouteMatch } from "react-router-dom";
import { EventParamTypes } from "../../../types/types";
import { BreadRoute } from "../../../components/breadcrumbs/BreadRoute";
import { BreadCrumb } from "../../../components/breadcrumbs/BreadCrumb";
import Card from "../../../components/utils/Card";

export const EventDetailsPage: React.FC = () => {
  const { id } = useParams<EventParamTypes>();
  let { url } = useRouteMatch();

  return (
    <div className='container w-screen h-screen'>
      <BreadRoute>
        <BreadCrumb label={"menu"} link={"/eventmenu"} />
        <BreadCrumb label={"events"} link={"/events"} />
        <BreadCrumb
          label={`event ${id}`}
          link={`/events/${id}`}
          lastChild={true}
        />
      </BreadRoute>
      <div className='container h-full max-h-11/12 w-full flex justify-center'>
        <Card
          header='Event.Card.SubEvents.Header'
          paragraph='Event.Card.SubEvents'
          link={`${url}/subevents`}
          linkStr={"Navigation.Event.SubEvents"}
          image='img/32628.jpg'
          canClick={true}
        />
        <Card
          header='Event.Card.Participant.Header'
          paragraph='Event.Card.Participant'
          link={`${url}/participants`}
          linkStr={"Navigation.Event.Participants"}
          image='img/2942529.jpg'
          canClick={true}
        />
        <Card
          header='Event.Card.Detail.Header'
          paragraph='Event.Card.Detail'
          link={`${url}/details`}
          linkStr={"Navigation.Event.Details"}
          image='img/Female magician performing before kid.jpg'
          canClick={true}
        />
      </div>
    </div>
  );
};
